<template>
  <svg
    id="icon-close"
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    :fill="fill"
    viewBox="0 0 24 25"
  >
    <path
      d="M7.938 16.69a.758.758 0 0 1-.206-.363.89.89 0 0 1 0-.419.742.742 0 0 1 .2-.356l2.931-2.931-2.931-2.925a.742.742 0 0 1-.2-.357.863.863 0 0 1 0-.412.758.758 0 0 1 .563-.569.793.793 0 0 1 .418 0 .767.767 0 0 1 .363.194L12 11.483l2.931-2.925c.1-.1.217-.166.35-.2a.77.77 0 0 1 .412 0 .721.721 0 0 1 .363.206c.108.1.18.221.213.363a.862.862 0 0 1 0 .412.72.72 0 0 1-.207.357l-2.918 2.925 2.918 2.931a.72.72 0 0 1 .207.356.888.888 0 0 1 0 .419.7.7 0 0 1-.213.356.763.763 0 0 1-.362.213.864.864 0 0 1-.413 0 .72.72 0 0 1-.35-.207l-2.931-2.925-2.925 2.932a.816.816 0 0 1-.363.2.89.89 0 0 1-.418 0 .789.789 0 0 1-.357-.207Z"
    />
  </svg>
</template>

<script>
import { iconPropsFunc } from "./mixins/icons";

export default {
  name: "IconClose",
  mixins: [iconPropsFunc()],
};
</script>

<style lang="scss" scoped></style>
